import React, { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "modules/auth/hooks";
import { useSports } from "modules/sport/hooks";
import {
  Navbar,
  Nav as NavBar,
  NavDropdown,
  Form,
  FormControl,
  Button,
  Image,
  Container
} from "react-bootstrap";
import { FilterList, Search } from "@mui/icons-material";

import "./Nav.styles.css";

export const Nav = () => {
  const navigate = useNavigate();
  const { user, login, logout } = useAuth();
  const { sports } = useSports();
  const location = useLocation();
  const isHome = location.pathname === "/";

  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  }

  const handleItemClick = () => {
    handleClose();
  };

  const navbarSports = useMemo(
    () =>
      sports.map(({ uuid, name }) => (
        <NavBar.Item>
          <Link style={{ width: name === 'icehockey' ? '80px' : '' }} key={uuid} onClick={handleItemClick} data-toggle="collapse" className="nav-link" to={`/sport/${name}`}>
            {name === 'icehockey' ? 'Ice Hockey' : name}
          </Link>
        </NavBar.Item>
      )),
    [sports]
  );

  return (
    <div
      className={`nav-wrapper ${!isHome ? "bg-black" : ""}`}
      style={{
        position: isHome ? "fixed" : "fixed",
        zIndex: "1000",
        width: "100%"
      }}
    >
      {!isHome && (
        <Container fluid>
          <Navbar expand="lg" className="d-flex justify-content-between test" expanded={isOpen}>
            <div
              className="d-flex justify-content-between col-6 first-col"
              data-target=".navbar-collapse"
            >
              <Navbar.Brand
                style={{ cursor: "pointer" }}
                onClick={() => navigate(user ? "/home" : "/")}
              >
                <Image
                  src="/staidium_demo_logo.svg"
                  alt="Logo"
                  className="normal-logo"
                  width={"162px"}
                />

                <Image
                  src="/Staidium_Icon.svg"
                  alt="Logo"
                  width="50px"
                  className="sub-logo"
                />
              </Navbar.Brand>

              <Navbar.Collapse id="basic-navbar-nav">
                <Navbar className="mr-auto">
                  <NavBar.Item>
                    <Link onClick={handleItemClick} className="nav-link" to={user ? "/home" : "/"}>
                      Home
                    </Link>
                  </NavBar.Item>
                  {navbarSports}
                </Navbar>
              </Navbar.Collapse>
            </div>

            <div className="d-flex col-6 justify-content-end align-items-center gap-3 second-col">
              <div className="nav-action" style={{ display: "none" }}>
                <a href="#">
                  <Search />
                </a>
                <div style={{ display: "none" }}>
                  <Form action="/search" method="GET">
                    <FormControl
                      type="text"
                      name="suchbegriff"
                      placeholder="Search"
                    />
                    <Button type="submit" className="button-search">
                      <i className="zmdi zmdi-search"></i>
                    </Button>
                  </Form>
                </div>
              </div>

              {/* <div className='separator' /> */}

              <div className="nav-action">
                <Link to="/search">
                  <Search />
                </Link>
              </div>

              <div className="separator" />

              {user && (
                <NavDropdown
                  title={
                    <img
                      src="/profilepic.png"
                      width={"32px"}
                      style={{ borderRadius: "13px" }}
                    />
                  }
                >
                  <Link to="/profile" className="dropdown-item">
                    My Account
                  </Link>
                  <Link to="#" onClick={logout} className="dropdown-item">
                    Logout
                  </Link>
                </NavDropdown>
              )}

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {user ? (
                  <div
                    className="subscribe-btn-wrap btn-danger"
                    style={{ display: !user ? "none" : "block" }}
                  >
                    {!user ? (
                      <Button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        className="subscribe-btn btn-danger"
                        style={{
                          border: "none",
                          color: "#fff",
                          borderRadius: "4px",
                          display: "inline-block",
                          lineHeight: 1,
                          padding: "10px 15px",
                          fontWeight: 500,
                          backgroundColor: "#f4181c",
                          transition: "all 0.4s ease 0s",
                          marginLeft: "15px"
                        }}
                      >
                        Subscribe Now
                      </Button>
                    ) : null}
                  </div>
                ) : (
                  <div
                    className="subscribe-btn-wrap btn-danger"
                    onClick={login}
                  >
                    <Button
                      type="button"
                      variant="danger"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      className="sign-in-up-btn-style"
                    >
                      Sign In
                    </Button>
                  </div>
                )}
              </div>

              <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle} />
            </div>
          </Navbar>
        </Container>
      )}

      {isHome && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {user ? (
            <div className="subscribe-btn-wrap btn-danger">
              {!user ? (
                <Button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  className="subscribe-btn btn-danger"
                  style={{
                    border: "none",
                    color: "#fff",
                    borderRadius: "4px",
                    display: "inline-block",
                    lineHeight: 1,
                    padding: "10px 15px",
                    fontWeight: 500,
                    backgroundColor: "#f4181c",
                    transition: "all 0.4s ease 0s",
                    marginLeft: "15px"
                  }}
                >
                  Subscribe Now
                </Button>
              ) : null}
            </div>
          ) : (
            <div className="subscribe-btn-wrap btn-danger" onClick={login}>
              <Button
                type="button"
                variant="danger"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                className="sign-in-up-btn-style"
              >
                Sign In
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
